import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseHttpService } from '../http/base.http.service';
import { ApiRouterService } from '../http/api.router';
import { LoginScope } from 'src/app/models/enums';

@Injectable({
  providedIn: 'root',
})
export class AuthHttpService extends BaseHttpService {
  private baseURL = ``;

  constructor(
    httpClient: HttpClient,
    private routerService: ApiRouterService
  ) {
    super(httpClient);
  }

  public login(email: string, password: string) {
    const path = `login`;
    const url = this.routerService.mount(`${this.baseURL}${path}`, true);
    // TODO:
    //return this.create({scope: LoginScope.BACKOFFICE, username: email, password: password, sha: this.utilsService.encryptSHA256(password)}, url);
    return this.create({ scope: LoginScope.BACKOFFICE, username: email, password: password }, url, undefined, {observe: 'response'});
  }

  public verifyCode(username: string, totp: string, ephemeralToken: string, rememberMe: boolean) {
    const path = `2FA/verify`;
    const url = this.routerService.mount(`${this.baseURL}${path}`, true);
    return this.create({ scope: LoginScope.BACKOFFICE, username, totp, rememberMe }, url, [{key: 'X-BOD-EPHEMERAL-TOKEN', value: ephemeralToken}], {observe: 'response'});
  }

  public passwordReset(password: string, ephemeralToken: string) {
    const path = `login/password-reset`;
    const url = this.routerService.mount(`${this.baseURL}${path}`, true);
    return this.updatePatch({ password }, url, [{key: 'X-BOD-EPHEMERAL-TOKEN', value: ephemeralToken}], {observe: 'response'});
  }

  public refreshToken(userId: string, refreshToken: string) {
    const path = `refresh-token`;
    const url = this.routerService.mount(`${this.baseURL}${path}?user_id=${userId}&scope=${LoginScope.BACKOFFICE}`, true);
    return this.create({}, url, [{key: 'X-BOD-REFRESH-TOKEN', value: refreshToken}], {observe: 'response'});
  }

  public getEphemeralToken() {
    const path = `ephemeral-token`;
    const url = this.routerService.mount(`${this.baseURL}${path}`, true);
    return this.readText(url);
  }
}
